<template>
  <div class="download-area">
    <h3>下载软件安装包</h3>
    <p>感谢您申请试用我们的软件。请点击下方按钮下载安装包：</p>
    <el-button type="primary" @click="downloadSoftware">下载安装包</el-button>
    <el-button @click="closeDialog">关闭</el-button>
    <div v-if="showInstallInstructions" class="install-instructions">
      <h4>下载已开始</h4>
      <p>请注意：</p>
      <ol>
        <li>下载完成后，请找到下载的文件（通常在您的"下载"文件夹中）。</li>
        <li>双击下载的文件以开始安装过程。</li>
        <li>按照安装向导的指示完成安装。</li>
        <li>安装完成后，您就可以启动并使用 DiCloudAccess 了。</li>
      </ol>
      <p>如果您在安装过程中遇到任何问题，请随时联系我们的支持团队。</p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { defineEmits } from 'vue';

const emit = defineEmits(['close', 'download-complete']);
const showInstallInstructions = ref(false);

const downloadSoftware = async () => {
  const filename = window.RUNTIME_CONFIG?.downloadFilename;
  // 同源相对路径，避免 HTTPS 页面跳到 http 下载域名
  const downloadBaseUrl = process.env.VUE_APP_DOWNLOAD_BASE_URL || '/downloads';
  
  try {
    if (!downloadBaseUrl || !filename) {
      throw new Error('下载地址未配置');
    }

    const normalizedBaseUrl = downloadBaseUrl.replace(/\/+$/, '');
    const normalizedFilename = String(filename).replace(/^\/+/, '');
    const downloadUrl = `${normalizedBaseUrl}/${normalizedFilename}`;
    
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.target = '_blank';
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    ElMessage.success('下载已开始');
    showInstallInstructions.value = true;
  } catch (error) {
    console.error('下载失败:', error);
    ElMessage.error(`下载失败: ${error.message}`);
  }
};

const closeDialog = () => {
  emit('close');
};
</script>

<style scoped>
.download-area {
  text-align: center;
}

.download-area h3 {
  margin-bottom: 20px;
}

.download-area p {
  margin-bottom: 30px;
}

.el-button {
  margin: 0 10px;
}

.install-instructions {
  margin-top: 30px;
  text-align: left;
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  border-radius: 4px;
  padding: 20px;
}

.install-instructions h4 {
  color: #67c23a;
  margin-bottom: 15px;
}

.install-instructions ol {
  padding-left: 20px;
}

.install-instructions li {
  margin-bottom: 10px;
}
</style>